import { render, staticRenderFns } from "./shift-auth-list.vue?vue&type=template&id=0bcb267c&scoped=true&"
import script from "./shift-auth-list.vue?vue&type=script&lang=js&"
export * from "./shift-auth-list.vue?vue&type=script&lang=js&"
import style0 from "./shift-auth-list.vue?vue&type=style&index=0&id=0bcb267c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb267c",
  null
  
)

export default component.exports